import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

/**
 * Per-user view preferences, keyed by view_key. Responses use the standard
 * { data, message } envelope. The payload shape is view-specific.
 */
const getViewPreference = <T = Record<string, unknown>>(
  viewKey: string,
): Promise<AxiosResponse<{ data: T }>> => {
  return api.get(`/view-preferences/${viewKey}/`);
};

const saveViewPreference = <T = Record<string, unknown>>(
  viewKey: string,
  preferences: T,
): Promise<AxiosResponse<{ data: T }>> => {
  return api.put(`/view-preferences/${viewKey}/`, preferences);
};

export default {
  getViewPreference,
  saveViewPreference,
};
